module.exports = __webpack_public_path__ + "static/media/book formatting (3).8e470bc3.png";